module.exports = __webpack_public_path__ + "img/savvix_logo.4a785dec.png";